import { render, staticRenderFns } from "./dialog-detailrestore.vue?vue&type=template&id=6e8c9a53&"
import script from "./dialog-detailrestore.vue?vue&type=script&lang=js&"
export * from "./dialog-detailrestore.vue?vue&type=script&lang=js&"
import style0 from "./dialog-detailrestore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports